require('../../modules/es6.object.assign');
module.exports = require('../../modules/$.core').Object.assign;


//////////////////
// WEBPACK FOOTER
// C:/wamp/www/node_modules/core-js/library/fn/object/assign.js
// module id = 217
// module chunks = 0